import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { DynamicComponentsService } from 'src/app/___LOGIC/__dynamicComponent/dynamic-components.service';
import { ShopifyService } from 'src/app/___LOGIC/__shopify/shopify.service';
import { OrdersService } from 'src/app/___LOGIC/__orders/orders.service';

@Component({
  selector: 'app-migration-helper',
  templateUrl: './migration-helper.component.html',
  styleUrls: ['./migration-helper.component.css']
})
export class MigrationHelperComponent implements OnInit {

  introSection = {
    cardId: 'A',
    imageUrl: this.guiFlow.getImage('10399059-2cae-4a05-faa8-9754e746e600','public'),
    // 10399059-2cae-4a05-faa8-9754e746e600
    // Photo by <a href="https://unsplash.com/@kanderson17?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Kylie Anderson</a> on <a href="https://unsplash.com/photos/person-holding-canada-passport-aGDILBE1Kus?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
    imageSize: 'md',
    title: 'Trámites Extranjería',
    longPar: '',
    longParLimit: '250',
    categories : ['Extranjería','Estudiantes'],
    shortPara: 'En esta sección de nuestra plataforma, estamos aquí para facilitarte todos los procesos que necesitas llevar a cabo como estudiante extranjero que planea estudiar en España.',
    description: 'Nuestra misión es simplificar tu experiencia. Queremos que tu transición a España como estudiante sea lo más sencilla posible. Estamos aquí para responder a tus preguntas y brindarte el apoyo necesario en cada paso del camino. No dudes en explorar nuestra sección de Migración para Estudiantes y prepárate para una experiencia académica enriquecedora en España.¡Bienvenido a esta nueva aventura académica!',
    array: [
      {
        subtitle: 'Información detallada:',
        text: 'Te proporcionamos información exhaustiva sobre los procedimientos de migración que debes seguir como estudiante extranjero.'
      },
      {
        subtitle: 'Asesoramiento personalizado:',
        text: 'Te ayudamos a entender los requisitos específicos, dónde obtener los documentos necesarios y cómo programar tus citas.'
      },
      {
        subtitle: 'Plazos y tiempos:',
        text: 'Te ofrecemos una guía sobre los plazos típicos para cada etapa del proceso, para que puedas planificar tu viaje y estudios sin preocupaciones.'
      },
      {
        subtitle: 'Paso a paso: ',
        text: 'Un desglose detallado y fácil de seguir de todos los pasos requeridos para obtener tu visa de estudiante y completar los trámites de migración.'
      },
      {
        subtitle: 'Enlaces útiles: ',
        text: 'Recursos y enlaces directos a las páginas oficiales donde puedes obtener información actualizada y realizar citas para tus trámites.'
      }
    ]
  };

  explicacionNieTie = {
    imageUrl: this.guiFlow.getImage('03a77db9-6212-43e2-628f-d80e15685000','public'),
    imageSize: 'md',
    title: 'NIE y TIE en España',
    subtitle: '¿Que son el NIE y el TIE?',
    longPar: 'Es necesario para realizar trámites como por ejemplo abrir una cuenta de banco, pagar impuestos, también para realizar operaciones y transacciones como compra o venta de inmuebles o automóviles, en lo que respecta a actividades económicas como registrar una empresa o trabajar y para acceder a seguridad social, entre otras cosas. Está compuesto de 9 dígitos con una letra al principio, siete números y otra letra al final. A modo de ejemplo, se vería así: “A1234567B”.',
    longParLimit: '250',
    shortPara: 'El Número de Identidad del Extranjero (NIE) es personal, único y exclusivo, de carácter secuencial, que identifica a la persona extranjera ante la Administración española.Estamos hablando de un número que nunca cambiará y que te acompañará durante toda tu vida (o hasta que obtengas la nacionalidad española).',
    description: 'Un ejemplo del NIE (no real, lo usaremos simplemente como ejemplo) se vería así: Y9125834A. Pero hay algo realmente importante que debes tener en cuenta. El número NIE no te permite residir legalmente en España.',
    array: [
      {
        subtitle: '¿Es el TIE lo mismo que el NIE?',
        text: 'La respuesta es simple: no. El TIE («Tarjeta de identidad de extranjero») es el documento físico que generalmente contiene el número NIE. Mientras que el NIE es únicamente un número de identificación, el TIE es aquello físico que lo lleva dentro. Así, puedes tener el número de NIE en España pero no la tarjeta. Además, el TIE contiene algo más que el NIE. En la TIE también encontramos una foto del titular y el tipo de autorización de residencia de que dispone. Esto implica que hay diferencias dentro de los distintos TIE. Cada tarjeta conlleva un tipo específico de permiso de residencia consigo.'
      },
      {
        subtitle: '¿Qué validez tiene el NIE?',
        text:   'El NIE para no residentes otorgado para aquellos que no quieren residir en España se concede en un documento que caduca a los 3 meses. Una vez pasado este plazo, y suponiendo que el extranjero quiere realizar algún otro trámite, deberá renovarlo para poder operar con validez legal. No obstante, esto no significa que deba conseguir un nuevo NIE. El número en sí seguirá siendo el mismo. Pues únicamente tendremos uno durante toda nuestra vida. En caso de ser necesario, lo que se renueva es el papel que lo concede.'
      },
      {
        subtitle: 'Plazo de solicitud',
        text: 'Tienes hasta un mes desde tu entrada al país, obtención o entrada en vigor de la autorización de residencia para realizar el trámite. Recuerda que tienes que disponer de una autorización para permanecer en el país por un período superior a los 6 meses para optar al TIE.'
      },
      {
        subtitle: 'Vigencia de la tarjeta',
        text: 'Ten en cuenta que la vigencia de la Tarjeta de Identidad de Extranjero es la que se indica en la autorización para justificar su expedición. En el caso de que pierdas el derecho de permanencia en el país, el TIE deja de tener validez, por lo que deberás entregar la tarjeta en la Comisaría de Policía u Oficina de Extranjería más cercana a tu domicilio.'
      }
    ]
  };
  
  pasosParaNie = {
    title: '¿Qué pasos debes seguir?',
    array: [
      {
        text: 'Debes descargar, rellenar y firmar el modelo oficial de solicitud de NIE (formulario EX-15) por duplicado (solamente se encuentra disponible en castellano).',
        imageUrl: '',
        icon: 'fas fa-file-invoice timeline-icon'
      },
      {
        text: 'Recopila la documentación necesaria.',
        icon: 'fas fa-folder-open timeline-icon'
      },
      {
        text: 'Solicita la cita previa en línea.',
        icon: 'fas fa-calendar-day timeline-icon'
      },
      {
        text: 'Si estás dentro de España o si tienes un representante en España, accede a la sede electrónica del Gobierno y sigue las orientaciones de la página para la asignación de NIE (comunitarios y no comunitarios).'
      },
      {
        text: 'Si estás fuera de España, debes ponerte en contacto con la misión diplomática u oficina consular española correspondiente a tu demarcación de residencia y concertar cita previa según los procedimientos locales que sean aplicables.'
      },
      {
        text: 'Paga la tasa asociada al trámite. Puedes realizar el pago a través del formulario en línea (modelo 790 código 012). Rellena los campos del formulario (indicando la forma de pago), descárgalo e imprímelo. El importe asciende a 9,84 euros.El formulario permite el pago en efectivo (efectuando el ingreso en una entidad bancaria a favor del Tesoro Público) o bien el adeudo en cuenta corriente (cuyos números deberás facilitar). El formulario se encuentra disponible únicamente en castellano.',
        icon: 'fas fa-cash-register timeline-icon'
      },
      {
        text: 'Acude al lugar indicado en el que hayas concertado cita previa para entregar la documentación.',
        icon: 'fas fa-building timeline-icon'
      },
      {
        text: 'Recibe tu NIE.',
        icon: 'fas fa-id-card timeline-icon'
      }
    ]
  }

  requisitosNie = {
    cardId: 'D',
    title: 'Documentación necesaria',
    imageUrl: '../../assets/images/components/mobile/image1.png',
    longPar: 'Solicitar el NIE por primera vez no debería ser un proceso tedioso o desconcertante, por lo que hemos hecho una lista de los requisitos para vos:',
    longParLimit: '',
    shortPara: '',
    array: [
      {
        title: 'Formulario EX-15',
        description: 'Deberás completar y enviar el modelo EX-15 y el formulario para el NIE 790. Ten en cuenta que este documento viene con un impuesto asociado que deberás pagar',
      },
      {
        title: 'Pasaporte',
        description: 'Tu pasaporte y copias de todas las páginas'
      },
      {
        title: 'Volante de empadronamiento',
        description: 'Empadronamiento. Básicamente, esto implica el registro en la ciudad en la que vives'
      },
      {
        title: 'Fotografías',
        description: 'Dos fotos tamaño pasaporte'
      },
      {
        title: 'Asistir',
        description: 'Huellas digitales (esto no será necesario para el procedimiento de solicitud inicial)'
      },
      {
        title: 'Traducciones',
        description: 'Ten en cuenta que todos los documentos debe ser traducidos correctamente al español'
      }
    ]
  };

  empadronamiento = {
    cardId: 'D',
    title: 'Empadronamiento',
    imageUrl: 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/a20f854e-5215-4059-a2a1-18fcd77c2300/public',
    longPar: 'Es un proceso administrativo que consiste en registrarse oficialmente en el padrón municipal de una localidad. Este registro es obligatorio para todas las personas que residan en España de manera permanente o por un período superior a 6 meses, y es importante para obtener una serie de servicios y beneficios, así como para cumplir con ciertas obligaciones legales.',
    longParLimit: '',
    shortPara: '',
    array: [
      {
        title: 'Justo al llegar',
        description: 'Es fundamental para establecer tu dirección legal en el país y tiene varias implicaciones importantes.',
      },
      {
        title: 'Beneficios',
        description: 'Permite acceder a una serie de servicios y beneficios, como la atención médica en el sistema de salud público, la participación en elecciones locales y la solicitud de diversos documentos oficiales, como el certificado de empadronamiento.',
      },
      {
        title: 'Obligaciones',
        description: 'Es un requisito legal en España. No empadronarse cuando se está viviendo en el país de forma permanente puede llevar a sanciones legales, incluyendo multas.',
      },
      {
        title: 'Requisitos',
        description: 'Para empadronarte, debes ser residente en España, lo que implica que vives en el país de manera permanente o por un período superior a 6 meses.Requisitos: Para empadronarte, debes ser residente en España, lo que implica que vives en el país de manera permanente o por un período superior a 6 meses.',
      },
      {
        title: 'Obligaciones',
        description: 'Certificado (Volante) de Empadronamiento: Después de completar el proceso de empadronamiento, recibirás un certificado que acredita tu inscripción en el padrón municipal. Este documento es útil para realizar una variedad de trámites administrativos.',
      },
      {
        title: 'Actualización',
        description: 'Es importante mantener actualizados tus datos de empadronamiento si cambias de dirección en España. Debes informar al ayuntamiento de tu nuevo lugar de residencia.',
      }
    ]
  }

  requisitosEmpadronamiento = {
    cardId: 'D',
    title: 'Requisitos para el empadronamiento',
    imageUrl: '../../assets/images/components/mobile/image1.png',
    longPar: 'Es un proceso administrativo que consiste en registrarse oficialmente en el padrón municipal de una localidad. Este registro es obligatorio para todas las personas que residan en España de manera permanente o por un período superior a 6 meses, y es importante para obtener una serie de servicios y beneficios, así como para cumplir con ciertas obligaciones legales.',
    longParLimit: '',
    shortPara: '',
    array: [
      {
        title: 'PDF Hoja padronal',
        description: 'PDF Hoja padronal',
        button: 'PDF Hoja Padronal',
        buttonLink: 'hoja-padronal'
      },
      {
        title: 'Formulario',
        description: 'Descargar el formulario de la tasa y rellenarlo.',
      },
      {
        title: 'Tasa',
        description: 'Pagar la tasa en alguna entidad bancaria (de 8am a 11:30am) preferiblemente.',
      },
      {
        title: 'Descargar formularios',
        description: 'Descargar el modelo de solicitud.',
      },
      {
        title: 'Cita previa',
        description: 'Acceder al enlace del ayuntamiento de Madrid para concertar una cita previa',
      },
      {
        title: 'Provincia',
        description: 'Elegir Madrid en provincias disponibles',
      },
      {
        title: 'Fecha/hora',
        description: 'Elegir fecha y hora',
      },
      {
        title: 'Confirmación de cita',
        description: 'Revisar en el correo electrónico haber recibido la confirmación electrónica de la cita.'
      }
    ]
  };

  tipsPadron = {
    title: 'Consejos importantes',
    subtitle: '',
    imageUrl: '../../assets/images/components/mobile/image1.png',
    longPar: '',
    longParLimit: '',
    shortPara: '',
    allVisible: false,
    array: [
      {
        title: 'Ser el primero...',
        description: 'Ir tan pronto como sea posible a la oficina. Se llena muy rápido, así que si no quieres perder toda la mañana, asegúrate de estar el primero o la primera.',
        imageUrl: this.guiFlow.getImage('79f29d8b-a3c6-4604-d23b-17cf313e1500','icon'),
        visible: true
      },
      {
        title: 'Revisa tu pasaporte',
        description: 'Además, asegurate de traer tu pasaporte (original) y fotocopias, ya que es algo que muchos tienden a olvidar.',
        imageUrl: this.guiFlow.getImage('e24ab102-8a8b-4f30-c2af-493fc1668e00','icon'),
        visible: true
      },  
      {
        title: 'Recibo / sello',
        description: 'Te darán un recibo confirmando que ya has pagado: Con este recibo deberás dirigirse nuevamente a la Oficina de Policía y entregarlo, para así poder recibir tu número NIE.',
        imageUrl: this.guiFlow.getImage('adaf667c-75f2-4a31-5a55-95579d993300','icon'),
        visible: true
      }
    ]
  };

  cities: string[] = ['Madrid', 'Barcelona', 'Valencia', 'Sevilla'];
  selectedCity: string;
  nieTieSteps: any = {
    'Madrid': [
      'Step 1: Prepare the required documents.',
      'Step 2: Fill out the application form.',
      'Step 3: Make an appointment online.',
      'Step 4: Attend the appointment and submit your documents.',
      'Step 5: Collect your NIE/TIE after approval.'
    ],
    'Barcelona': [
      'Step 1: Prepare the required documents.',
      'Step 2: Fill out the application form.',
      'Step 3: Make an appointment online.',
      'Step 4: Attend the appointment and submit your documents.',
      'Step 5: Collect your NIE/TIE after approval.'
    ],
    'Valencia': [
      'Step 1: Prepare the required documents.',
      'Step 2: Fill out the application form.',
      'Step 3: Make an appointment online.',
      'Step 4: Attend the appointment and submit your documents.',
      'Step 5: Collect your NIE/TIE after approval.'
    ],
    'Sevilla': [
      'Step 1: Prepare the required documents.',
      'Step 2: Fill out the application form.',
      'Step 3: Make an appointment online.',
      'Step 4: Attend the appointment and submit your documents.',
      'Step 5: Collect your NIE/TIE after approval.'
    ]
  };
  empadronamientoSteps: any = {
    'Madrid': [
      'Step 1: Prepare the required documents.',
      'Step 2: Visit the local town hall.',
      'Step 3: Fill out the registration form.',
      'Step 4: Submit your documents and form.',
      'Step 5: Collect your registration certificate.'
    ],
    'Barcelona': [
      'Step 1: Prepare the required documents.',
      'Step 2: Visit the local town hall.',
      'Step 3: Fill out the registration form.',
      'Step 4: Submit your documents and form.',
      'Step 5: Collect your registration certificate.'
    ],
    'Valencia': [
      'Step 1: Prepare the required documents.',
      'Step 2: Visit the local town hall.',
      'Step 3: Fill out the registration form.',
      'Step 4: Submit your documents and form.',
      'Step 5: Collect your registration certificate.'
    ],
    'Sevilla': [
      'Step 1: Prepare the required documents.',
      'Step 2: Visit the local town hall.',
      'Step 3: Fill out the registration form.',
      'Step 4: Submit your documents and form.',
      'Step 5: Collect your registration certificate.'
    ]
  };

  sections = [];

  @ViewChildren('dynamicElement') elements: QueryList<ElementRef<HTMLDivElement>>;

  constructor(private guiFlow: GuiFlowService,private dynamicComponentsService: DynamicComponentsService,private shopifyService: ShopifyService,private ordersService: OrdersService) { 
    this.sections = [
      { id: 'intro', data: null, visible: true },
      { id: 'nie' },
      { id: 'pasosnie' },
      { id: 'requisitos' },
      { id: 'tipsPadron' },
      { id: 'requisitospadron' },
      { id: 'tips' }
    ];

    //
    this.requisitosNie['fieldForTitle'] = 'title';
    this.requisitosNie['fieldForContent'] = 'description';
    this.requisitosNie['productVariantId'] = 51024190439727;

    // Requisitos empadronamiento

    this.requisitosEmpadronamiento['fieldForTitle'] = 'title';
    this.requisitosEmpadronamiento['fieldForContent'] = 'description';
    this.requisitosEmpadronamiento['cta'] = 'Acceder al contenido';
    this.requisitosEmpadronamiento['cardId'] = 'A';
    this.requisitosEmpadronamiento['productVariantId'] = 51024190439727;

    /* Explicación empadrdonamiento */
    this.empadronamiento['fieldForTitle'] = 'title';
    this.empadronamiento['fieldForContent'] = 'description';

/*     this.tips['fieldForTitle'] = 'title';
    this.tips['fieldForContent'] = 'description'; */

    /* Explicación NIE-TIE */
    this.explicacionNieTie['fieldForTitle'] = 'subtitle';
    this.explicacionNieTie['fieldForContent'] = 'text';
  }

  ngOnInit(): void { }

  // AfterViewInit to register the elements
  ngAfterViewInit(): void {
    this.elements.forEach((el) => {
      const id = el.nativeElement.id; // Use the id attribute as the key
      this.dynamicComponentsService.registerElement(id, el);
    });
    console.log('Dynamic elements registered:', this.dynamicComponentsService);
  }

  selectCity(city: string) {
    this.selectedCity = city;
  }

  contactSupport() {
    // Implement logic to contact support
    console.log('Contacting support...');
  }

  // Scroll into view via the service
  scrollIntoView(key: string): void {
    this.dynamicComponentsService.scrollToElement(key);
  }

  openPdf(pdfId){
    /* this.router.navigateByUrl('pdf-view/'+pdfId); */
  }

  openAction(action){
    debugger
  }

  buyProduct(buyCta){
    // create an order object and set it to processing
    debugger
    let clientDetails = this.ordersService.getClientInfo();
    let orderDetails = {};
    /* this.resolver.createProcessingOrder(null,null);
    this.checkIsOrderProcessed('1'); */
    //
    this.shopifyService.buyProduct(buyCta);
  }
}
